import PropTypes from 'prop-types';

// material-ui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

// ==============================|| LOADING SCREEN ||============================== //

export default function LoadingScreen({ message = 'A carregar...', fullScreen = true, sx = {} }) {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          mb: 2
        }}
      >
        <CircularProgress size={38} thickness={4} color="primary" />
      </Box>

      {message && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            letterSpacing: '0.2px',
            textAlign: 'center',
            width: '100%',
            m: 0
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );

  if (!fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 200,
          width: '100%',
          ...sx
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.background?.default || '#fafafb',
        m: 0,
        p: 0,
        ...sx
      }}
    >
      {content}
    </Box>
  );
}

LoadingScreen.propTypes = {
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
  sx: PropTypes.object
};
